import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Badge, Card, Row, Col, Container, Spinner, Accordion, InputGroup, Alert } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { FaComments, FaQuestionCircle, FaPlus, FaSearch, FaPaperclip, FaChevronRight } from 'react-icons/fa';
import './index.css';

const usuario = localStorage.getItem("chapa");

function CentralDuvidasRH() {
    const [chamados, setChamados] = useState([]);
    const [assuntos, setAssuntos] = useState([]);
    const [mensagens, setMensagens] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const [showNovo, setShowNovo] = useState(false);
    const [idAssunto, setIdAssunto] = useState("");
    const [textoAssunto, setTextoAssunto] = useState("");
    const [faqSugestao, setFaqSugestao] = useState("");
    const [mensagem, setMensagem] = useState("");
    const [arquivo, setArquivo] = useState(null);

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [showFAQ, setShowFAQ] = useState(false);
    const [filtroFAQ, setFiltroFAQ] = useState("");
    const [selected, setSelected] = useState(null);
    const [escrevendoReplicado, setEscrevendoReplicado] = useState(false);
    const [mensagemReplicado, setMensagemReplicado] = useState("");
    const [arquivoReplicado, setArquivoReplicado] = useState(null);

    const [showPreview, setShowPreview] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewTipo, setPreviewTipo] = useState(null);
    const [previewNome, setPreviewNome] = useState(null);

    const fecharPreview = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setPreviewUrl(null);
        setPreviewTipo(null);
        setPreviewNome(null);
        setShowPreview(false);
    };

    const formatarDataHora = (isoString) => {
        if (!isoString) return "";

        const data = isoString.replace("Z", "");
        const dt = new Date(data);

        const dia = String(dt.getDate()).padStart(2, "0");
        const mes = String(dt.getMonth() + 1).padStart(2, "0");
        const ano = dt.getFullYear();
        const hora = String(dt.getHours()).padStart(2, "0");
        const minuto = String(dt.getMinutes()).padStart(2, "0");
        const segundo = String(dt.getSeconds()).padStart(2, "0");

        return `${dia}/${mes}/${ano}, ${hora}:${minuto}:${segundo}`;
    };

    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) {
            console.error("Erro ao codificar Base64:", e);
            return "";
        }
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const pad = base64.length % 4;
            if (pad !== 0) base64 += "=".repeat(4 - pad);
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            return new TextDecoder("utf-8").decode(bytes);
        } catch (e) {
            console.error("Erro ao decodificar Base64:", e, str);
            return str;
        }
    };

    useEffect(() => {
        loadChamados();
        loadAssuntos();
    }, []);

    const handleSelectAssunto = (id) => {
        setIdAssunto(id);
        const assuntoEncontrado = assuntos.find(a => String(a.ID_ASSUNTO || a.id_assunto) === String(id));
        if (assuntoEncontrado) {
            setTextoAssunto(assuntoEncontrado.DESCRICAO_ASSUNTO || assuntoEncontrado.descricao_assunto);
            setFaqSugestao(decodeBase64(decodeBase64(assuntoEncontrado.TEXTO_FAQ_ASSUNTO || assuntoEncontrado.texto_faq_assunto)));
        } else {
            setTextoAssunto("");
            setFaqSugestao("");
        }
    };

    const handleBuscarEVerArquivo = async (idChamado, idInteracao, nomeArquivo) => {
        try {
            setLoading(true);

            const response = await api.get(
                `/rh/chamado/${idChamado}/arquivo?id_interacao=${idInteracao}`
            );

            const dados = response.data;
            const base64Dados =
                (Array.isArray(dados) && dados.length > 0 &&
                    (dados[0].anexo_blob ||
                        dados[0].ANEXO_BLOB ||
                        dados[0].anexo_base64 ||
                        dados[0].ANEXO_BASE64)) ||
                dados?.anexo_blob ||
                dados?.ANEXO_BLOB ||
                dados?.anexo_base64 ||
                dados?.ANEXO_BASE64 ||
                dados;

            if (!base64Dados) {
                Swal.fire({
                    icon: "warning",
                    title: "Aviso",
                    text: "Arquivo não encontrado no servidor.",
                    confirmButtonColor: "#8b0000"
                });
                return;
            }

            abrirPreviewArquivo(base64Dados, nomeArquivo);
        } catch (err) {
            console.error("Erro ao buscar arquivo:", err);
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Falha ao recuperar o anexo.",
                confirmButtonColor: "#8b0000"
            });
        } finally {
            setLoading(false);
        }
    };

    const abrirPreviewArquivo = (base64, nomeArquivo) => {
        try {
            const base64Limpo = base64
                .replace(/^data:.*;base64,/, "")
                .replace(/\r?\n|\r/g, "")
                .trim();

            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);

            let type = "application/octet-stream";
            const ext = (nomeArquivo || "").toLowerCase();
            if (ext.endsWith(".pdf")) type = "application/pdf";
            else if (ext.endsWith(".png")) type = "image/png";
            else if (ext.endsWith(".jpg") || ext.endsWith(".jpeg")) type = "image/jpeg";

            const blob = new Blob([byteArray], { type });
            const url = URL.createObjectURL(blob);

            setPreviewUrl(url);
            setPreviewTipo(type);
            setPreviewNome(nomeArquivo || "arquivo");
            setShowPreview(true);
        } catch (err) {
            console.error("Erro ao abrir arquivo:", err);
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Falha ao abrir o arquivo.",
                confirmButtonColor: "#8b0000"
            });
        }
    };

    const renderPreviewConteudo = () => {
        if (!previewUrl || !previewTipo) return null;

        if (previewTipo.includes("pdf")) {
            return (
                <iframe
                    src={previewUrl}
                    title="Preview PDF"
                    style={{ width: "100%", height: "75vh", border: "none" }}
                />
            );
        }

        if (previewTipo.startsWith("image/")) {
            return (
                <img
                    src={previewUrl}
                    alt={previewNome || "Preview"}
                    style={{ maxWidth: "100%", maxHeight: "75vh", display: "block", margin: "0 auto" }}
                />
            );
        }

        return (
            <div className="text-center p-4">
                <p>Este tipo de ficheiro não pode ser visualizado diretamente.</p>
                <Button
                    className="fw-bold border-0 text-white"
                    style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                    onClick={() => {
                        const link = document.createElement("a");
                        link.href = previewUrl;
                        link.download = previewNome || "arquivo";
                        link.click();
                    }}
                >
                    Descarregar ficheiro
                </Button>
            </div>
        );
    };

    const loadChamados = async () => {
        setLoading(true);
        try {
            const response = await api.get(`/rh/chamados/${usuario}`);
            setChamados(response.data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    const loadAssuntos = async () => {
        try {
            const response = await api.get('/rh/assuntos');
            setAssuntos(response.data);
        } catch (err) { console.error(err); }
    };

    const handleAbrirDetalhes = async (chamado) => {
        setSelected(chamado);
        setEscrevendoReplicado(false);
        setMensagemReplicado("");
        setArquivoReplicado(null);
        setLoadingDetalhes(true);
        try {
            const response = await api.get(`/rh/chamado/${chamado.id_chamado || chamado.ID_CHAMADO}/interacoes`);
            setMensagens(response.data || []);
            setShowDetalhes(true);
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Não foi possível carregar o histórico.',
                confirmButtonColor: '#8b0000'
            });
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const handleSalvar = async () => {
        const textoPuro = mensagem.replace(/<(.|\n)*?>/g, '').trim();
        if (!textoAssunto.trim() || !textoPuro) {
            return Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Preencha o assunto e a dúvida!',
                confirmButtonColor: '#8b0000'
            });
        }

        setLoading(true);
        try {
            let arquivoBase64 = "";
            let nomeArquivo = "";

            if (arquivo) {
                const reader = new FileReader();
                arquivoBase64 = await new Promise((resolve) => {
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.readAsDataURL(arquivo);
                });
                nomeArquivo = arquivo.name;
            }

            await api.post('/rh/chamado', {
                chapa: usuario,
                id_assunto: idAssunto ? parseInt(idAssunto) : null,
                descricao_assunto_manual: textoAssunto,
                assunto_custom: textoAssunto,
                mensagem: encodeBase64(mensagem),
                anexo_base64: arquivoBase64,
                nome_arquivo: nomeArquivo
            });

            Swal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: 'Dúvida enviada ao RH!',
                confirmButtonColor: '#8b0000'
            });
            setShowNovo(false);
            setMensagem(""); setArquivo(null); setIdAssunto(""); setTextoAssunto(""); setFaqSugestao("");
            loadChamados();
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Falha ao enviar solicitação.',
                confirmButtonColor: '#8b0000'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleFinalizar = async () => {
        try {
            await api.put(`/rh/chamado/finalizar/${selected.id_chamado || selected.ID_CHAMADO}`, {
                chapa: usuario,
                mensagem: encodeBase64("Chamado finalizado com sucesso pelo colaborador")
            });
            Swal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: 'Atendimento finalizado!',
                confirmButtonColor: '#8b0000'
            });
            setShowDetalhes(false);
            loadChamados();
        } catch (err) {
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Falha ao finalizar atendimento.',
                confirmButtonColor: '#8b0000'
            });
        }
    };

    const handleNaoConcordo = async () => {
        const textoPuro = mensagemReplicado.replace(/<(.|\n)*?>/g, "").trim();
        if (!textoPuro) {
            Swal.fire({
                icon: "warning",
                title: "Atenção",
                text: "Explique a sua dúvida.",
                confirmButtonColor: "#8b0000"
            });
            return;
        }

        try {
            let arquivoBase64 = "";
            let nomeArquivo = "";

            if (arquivoReplicado) {
                const reader = new FileReader();
                arquivoBase64 = await new Promise((resolve) => {
                    reader.onloadend = () => resolve(reader.result.split(",")[1]);
                    reader.readAsDataURL(arquivoReplicado);
                });
                nomeArquivo = arquivoReplicado.name;
            }

            await api.put(`/rh/chamado/transferir/${selected.id_chamado || selected.ID_CHAMADO}`, {
                chapa: usuario,
                mensagem: encodeBase64(mensagemReplicado),
                arquivo: arquivoBase64,
                nome_arquivo: nomeArquivo,
            });

            Swal.fire({
                icon: "success",
                title: "Enviado",
                text: "A sua réplica foi enviada ao RH.",
                confirmButtonColor: "#8b0000"
            });
            setShowDetalhes(false);
            loadChamados();
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Erro",
                text: "Falha ao transferir solicitação.",
                confirmButtonColor: "#8b0000"
            });
        }
    };

    const renderBadgeStatus = (status) => {
        const s = parseInt(status);
        switch (s) {
            case 0: return <Badge bg="warning" text="dark" className="px-2 py-1">AGUARDANDO RH</Badge>;
            case 1: return <Badge bg="info" className="px-2 py-1">RESPONDIDO (AUTO)</Badge>;
            case 2: return <Badge bg="success" className="px-2 py-1">RESPONDIDO</Badge>;
            case 3: return <Badge bg="secondary" className="px-2 py-1">FINALIZADO</Badge>;
            default: return <Badge bg="light" text="dark" className="px-2 py-1">N/A</Badge>;
        }
    };

    const faqsFiltrados = assuntos.filter(a =>
        (a.DESCRICAO_ASSUNTO || a.descricao_assunto || "").toLowerCase().includes(filtroFAQ.toLowerCase())
    );

    return (
        <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
            <Menu modulo="ARBOR" />

            <Container className="py-3 px-3 px-md-5" style={{ maxWidth: '1000px', margin: '0 auto' }}>
                <Row className="justify-content-center">
                    <Col xs={12}>
                        {/* CABEÇALHO */}
                        <div className="d-flex justify-content-between align-items-center bg-white p-3 p-md-4 rounded-4 shadow-sm mb-4 flex-wrap gap-2">
                            <div>
                                <h4 className="fw-bold text-dark m-0 d-flex align-items-center">
                                    <FaComments className="me-2 text-danger" />
                                    Central de Dúvidas RH
                                </h4>
                                <small className="text-muted">Envie dúvidas e acompanhe seus atendimentos com o RH</small>
                            </div>
                            <div className="d-flex gap-2">
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    className="fw-bold rounded-3 d-flex align-items-center gap-1.5"
                                    onClick={() => setShowFAQ(true)}
                                >
                                    <FaQuestionCircle /> FAQs
                                </Button>
                                <Button 
                                    size="sm" 
                                    className="fw-bold rounded-3 text-white border-0 d-flex align-items-center gap-1.5"
                                    style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                                    onClick={() => setShowNovo(true)}
                                >
                                    <FaPlus /> Nova Dúvida
                                </Button>
                            </div>
                        </div>

                        {/* LISTA DE ATENDIMENTOS */}
                        <div className="custom-scroll" style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto' }}>
                            {loading && (
                                <div className="text-center py-5">
                                    <Spinner animation="border" variant="danger" />
                                    <p className="mt-2 text-muted small">A carregar solicitações...</p>
                                </div>
                            )}

                            {!loading && chamados.length === 0 && (
                                <Card className="border-0 shadow-sm rounded-4 p-5 text-center bg-white">
                                    <FaComments className="text-muted opacity-50 mb-3 mx-auto" size={48} />
                                    <h5 className="fw-bold text-dark mb-1">Nenhum atendimento aberto</h5>
                                    <p className="text-muted small mb-0">Clique em "Nova Dúvida" para enviar a sua mensagem ao Recursos Humanos.</p>
                                </Card>
                            )}

                            {!loading && chamados.map(item => {
                                const status = item.status_chamado ?? item.STATUS_CHAMADO;
                                return (
                                    <Card 
                                        key={item.id_chamado || item.ID_CHAMADO} 
                                        className="border-0 shadow-sm rounded-4 mb-3 card-item overflow-hidden bg-white"
                                        onClick={() => handleAbrirDetalhes(item)}
                                    >
                                        <Card.Body className="p-3">
                                            <Row className="align-items-center g-2">
                                                <Col xs={10} md={11}>
                                                    <div className="mb-1">{renderBadgeStatus(status)}</div>
                                                    <h6 className="fw-bold mb-1 text-dark">{item.descricao_assunto || item.DESCRICAO_ASSUNTO || item.ASSUNTO_CUSTOM}</h6>
                                                    <div 
                                                        className="text-muted small mb-1 text-truncate"
                                                        dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(item.pergunta_chamado || item.PERGUNTA_CHAMADO)) }} 
                                                    />
                                                    <small className="text-secondary extra-small fw-semibold">
                                                        Última atualização: {formatarDataHora(item.ultimainteracao)}
                                                    </small>
                                                </Col>
                                                <Col xs={2} md={1} className="text-end">
                                                    <FaChevronRight className="text-muted" />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                );
                            })}
                        </div>
                    </Col>
                </Row>
            </Container>

            {/* MODAL DE CHAT / DETALHES */}
            <Modal show={showDetalhes} onHide={() => setShowDetalhes(false)} centered size="lg" className="rounded-4 overflow-hidden">
                <Modal.Header closeButton className="bg-danger text-white border-0 p-3" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}>
                    <Modal.Title className="fs-6 fw-bold text-white">Atendimento #{selected?.id_chamado || selected?.ID_CHAMADO}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-light p-3 p-md-4" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
                    <div className="d-flex flex-column gap-2">
                        {mensagens.map((msg, idx) => {
                            const autor = String(msg.TIPO_AUTOR || msg.tipo_autor || msg.ORIGEM || msg.origem || "").toUpperCase();
                            const dataHora = msg.datahora_interacao || msg.DATAHORA_INTERACAO || msg.data_interacao || msg.DATA_CADASTRO;
                            const temAnexo = msg.tem_anexo === "S" || msg.TEM_ANEXO === "S";

                            return (
                                <div key={idx} className={`balao-container ${autor === 'U' ? 'user' : 'rh'}`}>
                                    <div className="balao shadow-sm border">
                                        <small className={`d-block border-bottom pb-1 mb-1 fw-bold ${autor === 'U' ? 'text-primary' : 'text-danger'}`}>
                                            {autor === 'U' ? 'VOCÊ:' : 'RH:'}
                                        </small>

                                        <div className="small text-dark" dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(msg.MENSAGEM || msg.mensagem)) }} />

                                        {temAnexo && (
                                            <div className="mt-2 pt-2 border-top">
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="d-flex align-items-center gap-1.5 extra-small fw-bold rounded-3"
                                                    onClick={() => handleBuscarEVerArquivo(
                                                        selected?.id_chamado || selected?.ID_CHAMADO,
                                                        msg.id_interacao || msg.ID_INTERACAO,
                                                        msg.anexo_nome || msg.ANEXO_NOME || "arquivo"
                                                    )}
                                                >
                                                    <FaPaperclip /> Visualizar Ficheiro
                                                </Button>
                                            </div>
                                        )}

                                        <div className="text-end mt-1 text-muted extra-small">
                                            {formatarDataHora(dataHora)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                        {["1", "2"].includes(String(selected?.status_chamado ?? selected?.STATUS_CHAMADO)) && !escrevendoReplicado && (
                            <div className="mt-3 p-3 bg-white rounded-3 border shadow-sm text-center">
                                <p className="small fw-bold text-dark mb-3">O RH respondeu. Como deseja prosseguir?</p>
                                <div className="d-flex gap-2">
                                    <Button variant="success" className="w-100 fw-bold rounded-3" onClick={handleFinalizar}>RETORNO SATISFATÓRIO</Button>
                                    <Button variant="outline-danger" className="w-100 fw-bold rounded-3" onClick={() => setEscrevendoReplicado(true)}>NÃO ESTOU DE ACORDO</Button>
                                </div>
                            </div>
                        )}

                        {escrevendoReplicado && (
                            <div className="mt-3 bg-white p-3 rounded-3 shadow-sm border">
                                <Form.Label className="small fw-bold text-danger">Descreva o motivo da sua réplica:</Form.Label>
                                <ReactQuill theme="snow" value={mensagemReplicado} onChange={setMensagemReplicado} />

                                <Form.Group className="mt-2">
                                    <Form.Label className="small fw-bold">Anexar ficheiro (opcional)</Form.Label>
                                    <Form.Control
                                        type="file"
                                        size="sm"
                                        accept="image/*,.pdf"
                                        onChange={(e) => setArquivoReplicado(e.target.files[0])}
                                    />
                                </Form.Group>

                                <div className="d-flex gap-2 mt-3">
                                    <Button 
                                        className="btn-sm fw-bold border-0 rounded-3 text-white" 
                                        style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                                        onClick={handleNaoConcordo}
                                    >
                                        Enviar Réplica
                                    </Button>
                                    <Button variant="outline-secondary" size="sm" className="fw-bold rounded-3" onClick={() => setEscrevendoReplicado(false)}>Cancelar</Button>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top bg-light p-2.5">
                    <Button variant="secondary" size="sm" className="fw-bold px-3 rounded-3" onClick={() => setShowDetalhes(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL NOVA DÚVIDA */}
            <Modal show={showNovo} onHide={() => setShowNovo(false)} centered size="lg" className="rounded-4 overflow-hidden">
                <Modal.Header closeButton className="bg-danger text-white border-0 p-3" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}>
                    <Modal.Title className="fs-6 fw-bold text-white">Nova Dúvida para o RH</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3 p-md-4">
                    <Form.Group className="mb-3">
                        <Form.Label className="extra-small fw-bold text-muted">Selecione um Assunto</Form.Label>
                        <Form.Select className="form-select-sm" value={idAssunto} onChange={e => handleSelectAssunto(e.target.value)}>
                            <option value="">Outro / Assunto não listado</option>
                            {assuntos.map(a => <option key={a.ID_ASSUNTO || a.id_assunto} value={a.ID_ASSUNTO || a.id_assunto}>{a.DESCRICAO_ASSUNTO || a.descricao_assunto}</option>)}
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="extra-small fw-bold text-muted">Título do Assunto</Form.Label>
                        <Form.Control className="form-control-sm" type="text" placeholder="Ex: Erro no meu recibo de vencimento" value={textoAssunto} onChange={e => setTextoAssunto(e.target.value)} />
                    </Form.Group>

                    {faqSugestao && (
                        <Alert variant="info" className="py-2 shadow-sm border-start border-info border-4 rounded-3">
                            <h6 className="fw-bold mb-1 extra-small text-dark">
                                Dica do RH (FAQ):
                            </h6>
                            <div className="small text-dark" dangerouslySetInnerHTML={{ __html: faqSugestao }} />
                        </Alert>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label className="extra-small fw-bold text-muted">Sua dúvida detalhada</Form.Label>
                        <ReactQuill theme="snow" value={mensagem} onChange={setMensagem} />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label className="extra-small fw-bold text-muted">Anexar Ficheiro (Opcional)</Form.Label>
                        <Form.Control type="file" size="sm" onChange={(e) => setArquivo(e.target.files[0])} accept="image/*,.pdf" />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer className="border-top bg-light p-3">
                    <Button 
                        className="w-100 fw-bold border-0 rounded-3 py-2 text-white" 
                        style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}
                        onClick={handleSalvar} 
                        disabled={loading}
                    >
                        {loading ? <Spinner size="sm" animation="border" /> : "Enviar ao RH"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL FAQS */}
            <Modal show={showFAQ} onHide={() => setShowFAQ(false)} size="lg" centered className="rounded-4 overflow-hidden">
                <Modal.Header closeButton className="bg-danger text-white border-0 p-3" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)' }}>
                    <Modal.Title className="fs-6 fw-bold text-white">Perguntas Frequentes (FAQs)</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3 p-md-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <InputGroup className="mb-3">
                        <InputGroup.Text><FaSearch /></InputGroup.Text>
                        <Form.Control placeholder="Pesquisar em FAQs..." value={filtroFAQ} onChange={e => setFiltroFAQ(e.target.value)} />
                    </InputGroup>
                    <Accordion>
                        {faqsFiltrados.map((faq, idx) => (
                            <Accordion.Item eventKey={String(idx)} key={idx}>
                                <Accordion.Header>
                                    <span className="fw-bold text-dark small">
                                        {faq.DESCRICAO_ASSUNTO || faq.descricao_assunto}
                                    </span>
                                </Accordion.Header>
                                <Accordion.Body className="bg-light small text-dark">
                                    <div dangerouslySetInnerHTML={{ __html: decodeBase64(decodeBase64(faq.TEXTO_FAQ_ASSUNTO || faq.texto_faq_assunto)) }} />
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </Modal.Body>
                <Modal.Footer className="border-top bg-light p-2.5">
                    <Button variant="secondary" size="sm" className="fw-bold px-3 rounded-3" onClick={() => setShowFAQ(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL PREVIEW ANEXO */}
            <Modal show={showPreview} onHide={fecharPreview} size="xl" centered backdrop="static" className="rounded-4 overflow-hidden">
                <Modal.Header closeButton className="bg-light border-0 p-3">
                    <Modal.Title className="fs-6 fw-bold text-dark">Ficheiro: {previewNome}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">
                    {renderPreviewConteudo()}
                </Modal.Body>
                <Modal.Footer className="border-top bg-light p-2.5">
                    <Button variant="secondary" size="sm" className="fw-bold px-3 rounded-3" onClick={fecharPreview}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            <Footer />
        </div>
    );
}

export default CentralDuvidasRH;